import "./css/bootstrap.css";
import "./css/Footer.css";

function Footer() {
    return (

<div class="text-center text-lg-start bg-light rounded h1" id="rodape">

<section
class="d-flex justify-content justify-content-lg-between p-4 border-bottom"
>

<div class="me-5 d-none d-lg-block">
<span>Afrofuturo nas Redes Sociais:</span>
</div>



<div>
<a href="" class="me-4 text-reset">
<i class="fab fa-facebook-f"></i>
</a>
<a href="" class="me-4 text-reset">
<i class="fab fa-twitter"></i>
</a>
<a href="" class="me-4 text-reset">
<i class="fab fa-google"></i>
</a>
<a href="" class="me-4 text-reset">
<i class="fab fa-instagram"></i>
</a>
<a href="" class="me-4 text-reset">
<i class="fab fa-linkedin"></i>
</a>
<a href="" class="me-4 text-reset">
<i class="fab fa-github"></i>
</a>
</div>
</section>
<div class="container text-center text-md-start mt-5">

<div class="row mt-3">

<div class="col-md-12 col-lg-12 col-xl-12 text-center mx-auto mb-4">

<h6 class="text-uppercase fw-bold mb-4">
<i class="fas fa-gem me-3"></i>Uma tesouro escondido no dia de amanhã
</h6>
<p>
 O Afrofuturismo é um tema que vem ganhando força pois possibilita recuperar culturalmente um passado no qual sempre esteve limitado ou até mesmo oculto, como o protagonismo do negro nas artes, na ciência, na estética visual e na escrita.</p>
 <p>
 Este movimento cultural tem por fio condutor a criatividade, a inovação e a informação de valores que levam ao autoconhecimento e instigam a inventividade. O afrofuturismo estimula a romper as barreiras das limitações e focar nas inúmeras possibilidades no campo das ideias concretizando-as de maneira a exaltar e valorizar a capacidade intelectual de uma parcela da sociedade injustamente pouco valorizada. 
</p>
</div>

<div class="text-center p-4">
© 2021 Copyright:
<a class="text-reset fw-bold" href="https://github.com/renanjansen">Renan Jansen</a>
</div>
</div>
</div>
</div>


   );
}

export default Footer;